import React from 'react'
import './CircleShape.css'


export default function CircleShape() {
  return (
    <div className='circles'>
     <div className='circle-blue-one'></div>
     <div className='circle-blue-two'></div>
     <div className='circle-orange'></div>
     <div className='circle-pink-one'></div>
     <div className='circle-pink-two'></div>
     <div className='lines'>
          <div className='line line1'></div>
          <div className='line line2'></div>
          <div className='line line3'></div>
     </div>
    </div>
  )
}
